var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogotypeTelegramM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logotype_telegram_m"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0003 18.3333C14.6028 18.3333 18.3337 14.6025 18.3337 9.99999C18.3337 5.39749 14.6028 1.66666 10.0003 1.66666C5.39783 1.66666 1.66699 5.39749 1.66699 9.99999C1.66699 14.6025 5.39783 18.3333 10.0003 18.3333ZM14.0537 6.53249C14.182 6.65999 14.1795 6.93832 14.1512 7.12999L13.1703 13.5417C13.1228 13.8542 12.9778 14.2367 12.7278 14.3608C12.4512 14.4975 12.032 14.3925 11.7428 14.1983L8.98783 12.34C8.91901 12.2936 8.86143 12.2324 8.81932 12.1609C8.77721 12.0894 8.75162 12.0093 8.74443 11.9266C8.73724 11.844 8.74863 11.7607 8.77777 11.683C8.8069 11.6053 8.85305 11.5351 8.91283 11.4775L11.7353 8.74999C11.8128 8.67499 11.8553 8.53249 11.7903 8.45666C11.727 8.38082 11.5695 8.38999 11.4878 8.44582L8.00449 10.8225C7.45699 11.1958 6.77116 11.3058 6.13366 11.1233L4.89033 10.7508C4.68533 10.6875 4.50033 10.5442 4.49366 10.405C4.48783 10.2708 4.62533 10.1242 4.85616 10.0133L13.247 6.49666C13.5012 6.38916 13.892 6.36832 14.0537 6.53249Z",
    fill: "#70707A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogotypeTelegramM);
export default __webpack_public_path__ + "static/media/logotype_telegram_m.2c5e0c2428c53c8d240c88f18928bc71.svg";
export { ForwardRef as ReactComponent };